// removed by extract-text-webpack-plugin
module.exports = {"flex":"Navbar__flex___SCQtW","flex-column":"Navbar__flex-column___3TkJc","flex-column-center":"Navbar__flex-column-center___22OSx","flex-row":"Navbar__flex-row___hR2kY","appBar":"Navbar__appBar___2TEcD","wrapper":"Navbar__wrapper___JDMiD","flex-row-center":"Navbar__flex-row-center___2QfzW","avatar":"Navbar__avatar___1t893","avatar-text":"Navbar__avatar-text___SUi-v","brand":"Navbar__brand___1ZHoq","icon":"Navbar__icon___8DDGe","avatar-text-name":"Navbar__avatar-text-name___aQOZZ","link":"Navbar__link___22n7I","title":"Navbar__title___vZXWm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Navbar/Navbar.scss
// module id = 458
// module chunks = 7